export default __webpack_public_path__ + "static/media/36I-117164_-37346_0.507abff2.jpg";